module.exports = __webpack_public_path__ + "static/media/fa-regular-400.8b13141d.woff2";